import { post } from './http'
import global from '@/api/global'
var name = global.smpName
var crm = global.crm
var crmServer3 = global.crmServer3
// ---------------字典统计---------------------
// 字典管理--字典列表--新增
export const dictionaryAdd = p => post(name + '/smpDictionary/add', p)
// 字典管理--字典列表--修改
export const dictionaryChange = p => post(name + '/smpDictionary/update', p)
// 字典管理--字典列表--查询
export const dictionarySearch = p => post(name + '/smpDictionary/list', p)
// 字典管理--字典列表--组名下拉框
export const dictionarySelect = p => post(name + '/smpDictionary/listByGroupType', p)
// 字典管理--字典列表--删除
export const dictionaryDelete = p => post(name + '/smpDictionary/delete', p)
// ---------------组名维护---------------------
// 组名维护--新增
export const addGroupType = p => post(name + '/smpDictionary/addGroupType', p)
// 组名维护--修改
export const updateGroupType = p => post(name + '/smpDictionary/updateGroupType', p)
// 组名维护--删除
export const deleteGroupType = p => post(name + '/smpDictionary/delete', p)
// 组名维护--查看
export const seeGroupType = p => post(name + '/smpDictionary/listByGroupNoCommon', p)

// ---------------费用属性设置----------------------
// 费目新增
export const feeInfoAdd = p => post(name + '/feeInfo/add', p)
// 获取租户
export const getAllTenantData = p => post(name + '/costRule/getAllTenantData', p)
// 费目修改
export const feeInfoUpdate = p => post(name + '/feeInfo/update', p)
// 判断费目是否可以修改
export const checkSkuExist = p => post(name + '/feeAttribute/checkSkuExist', p)
// 费目启用停用
export const feeInfoUpdateStatus = p => post(name + '/feeInfo/updateStatus', p)
// 费目列表
export const feeInfoList = p => post(name + '/feeInfo/list', p)
// 判断费目是否能删除
export const feeCheckAttrExist = p => post(name + '/feeInfo/checkAttrExist', p)
// 费目删除
export const feeDelete = p => post(name + '/feeInfo/delete', p)
// 费目属性新增
export const feeAttributeAdd = p => post(name + '/feeAttribute/add', p)
// 获取费目属性新增-编码下拉框
export const feeAttributeBianMa = p => post(name + '/smpDictionary/listByGroupType', p)
// 费目属性列表
export const feeAttributeList = p => post(name + '/feeAttribute/list', p)
// 费目属性多属性-修改获取数据
export const feeAttributeManyChange = p => post(name + '/feeAttribute/findAttrGroupList', p)
// 费目属性-修改
export const feeAttributeUpdate = p => post(name + '/feeAttribute/update', p)
// 判断属性能否修改
export const feeAttributeCheckSkuExist = p => post(name + '/feeAttribute/checkSkuExist', p)
// 属性删除
export const feeAttributeDelete = p => post(name + '/feeAttribute/delete', p)
// -------------------设置明细字段--------------
// 新增
export const feelistDetailAdd = p => post(name + '/feelistDetail/add', p)
// 列表
export const feelistDetailList = p => post(name + '/feelistDetail/list', p)
// 修改
export const feelistDetailUpdate = p => post(name + '/feelistDetail/update', p)
// 删除
export const feelistDetailDelete = p => post(name + '/feelistDetail/delete', p)
// 判断能否删除
export const feelistDetailCheckSkuExist = p => post(name + '/feelistDetail/checkSkuExist', p)
// ----------------计费规则-仓储规则-------------
// tab数据
export const getSheetListBySysModel = p => post(name + '/costRule/getSheetListBySysModel', p)
// 查询接口
export const getCostDataList = p => post(name + '/costRule/getCostDataList', p)
// 计费规则页面新增、编辑页面变量字段接口
export const getCostPageData = p => post(name + '/costRule/getCostPageData', p)
// 新增
export const saveCostDataAdd = p => post(name + '/costRule/saveCostData', p)
// 删除
export const deleteCostData = p => post(name + '/costRule/deleteCostData', p)
// 所属客户
// export const getQueryCusterData = p => post('crm-server/crm/scustomer/queryCusterDataByTenantCode', p)
export let getQueryCusterData = p => {
  if (localStorage.getItem('isCutCrm3') == 1) {
    return post(`${crmServer3}/sCustomer/list`, { tenantCode: localStorage.getItem('tenantCode') })
  } else {
    return post(`${crm}/scustomer/queryCusterDataByTenantCode`, p)
  }
}
// --------------------结算管理------------------
// 查询
export const settlementBillList = p => post(name + '/tSettlementBill/list', p)
// 新增
export const settlementBillAdd = p => post(name + '/tSettlementBill/add', p)
// 费目多选框数据
export const listBySysModel = p => post(name + '/tSettlementBill/listOnFeeInfoBySysModel', p)
// 删除
export const settlementBillDelete = p => post(name + '/tSettlementBill/delete', p)
// 详情
export const settlementBillDetail = p => post(name + '/tSettlementBill/detail', p)
// 表格数据
export const settlementBillDetailData = p => post(name + '/tSettlementBill/detailAllData', p)
// 完成
export const updateStatusComplete = p => post(name + '/tSettlementBill/updateStatusComplete', p)
// 仓储结算单 开票完成
export const updateInvoiceStatusComplete = p => post(name + '/tSettlementBill/updateInvoiceStatusComplete', p)
// 修改仓储规则阶梯费率回显
export const getOverdueFeeLadderList = p => post(name + '/costRule/getOverdueFeeLadderList', p)
// 广州天又天结算-费用结算-新增获取结算费目
export const getSheetListBySysModelForWms = p => post(name + '/api/getSheetListBySysModelForWms', p)
